export function Loading() {
  return (
    <div className="full-loader">
      <h1 style={{ color: "red", marginTop: "2rem" }}>
        Please Wait Sending Transaction...
      </h1>
    </div>
  );
}
